module.exports = __webpack_public_path__ + "img/touxiangman.ba6e1deb.png";